import styled from "styled-components";

const MenuContainer = styled.div`
  width: 100%;
`;

export default { MenuContainer };
